import React from 'react';
import { X, Shield } from 'lucide-react';
interface PrivacyDisclaimerModalProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
  language: 'it' | 'de' | 'en';
}
const translations = {
  it: {
    title: 'Informativa sulla Privacy',
    content: `Benvenuto nella piattaforma Esonero Digitale di CNCE.

Prima di accedere, ti informiamo che:

• I tuoi dati personali saranno trattati in conformità al Regolamento UE 2016/679 (GDPR)
• Le informazioni raccolte saranno utilizzate esclusivamente per la gestione delle richieste di esonero per lavoratori distaccati all'estero
• I dati saranno conservati per il periodo necessario agli adempimenti di legge
• Hai diritto di accedere, rettificare, cancellare i tuoi dati personali in qualsiasi momento
• I dati saranno protetti con misure di sicurezza tecniche e organizzative adeguate

Per maggiori informazioni, consulta la nostra informativa completa sulla privacy disponibile sul sito CNCE.

Accedendo alla piattaforma, accetti il trattamento dei tuoi dati personali secondo le modalità sopra descritte.`,
    accept: 'Accetto',
    decline: 'Rifiuto'
  },
  de: {
    title: 'Datenschutzerklärung',
    content: `Willkommen auf der Esonero Digitale Plattform von CNCE.

Bevor Sie fortfahren, informieren wir Sie:

• Ihre personenbezogenen Daten werden gemäß der EU-Verordnung 2016/679 (DSGVO) verarbeitet
• Die gesammelten Informationen werden ausschließlich zur Verwaltung von Befreiungsanträgen für ins Ausland entsandte Arbeitnehmer verwendet
• Die Daten werden für den gesetzlich erforderlichen Zeitraum aufbewahrt
• Sie haben das Recht, jederzeit auf Ihre personenbezogenen Daten zuzugreifen, diese zu berichtigen oder zu löschen
• Die Daten werden durch angemessene technische und organisatorische Sicherheitsmaßnahmen geschützt

Weitere Informationen finden Sie in unserer vollständigen Datenschutzerklärung auf der CNCE-Website.

Mit dem Zugriff auf die Plattform akzeptieren Sie die Verarbeitung Ihrer personenbezogenen Daten wie oben beschrieben.`,
    accept: 'Akzeptieren',
    decline: 'Ablehnen'
  },
  en: {
    title: 'Privacy Notice',
    content: `Welcome to the CNCE Esonero Digitale platform.

Before proceeding, we inform you that:

• Your personal data will be processed in accordance with EU Regulation 2016/679 (GDPR)
• The information collected will be used exclusively for managing exemption requests for workers posted abroad
• Data will be retained for the period required by law
• You have the right to access, rectify, delete your personal data at any time
• Data will be protected with appropriate technical and organizational security measures

For more information, please consult our complete privacy policy available on the CNCE website.

By accessing the platform, you accept the processing of your personal data as described above.`,
    accept: 'Accept',
    decline: 'Decline'
  }
};
export function PrivacyDisclaimerModal({
  isOpen,
  onAccept,
  onDecline,
  language
}: PrivacyDisclaimerModalProps) {
  const t = translations[language];
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-274">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col" data-id="element-275">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-276">
          <div className="flex items-center gap-3" data-id="element-277">
            <Shield className="text-blue-600" size={24} data-id="element-278" />
            <h2 className="text-xl font-semibold text-gray-900" data-id="element-279">{t.title}</h2>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6" data-id="element-280">
          <div className="prose prose-sm max-w-none" data-id="element-281">
            <p className="text-gray-700 whitespace-pre-line leading-relaxed" data-id="element-282">
              {t.content}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex flex-col sm:flex-row gap-3 p-6 border-t border-gray-200" data-id="element-283">
          <button onClick={onDecline} className="flex-1 px-4 py-3 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors font-medium" data-id="element-284">
            {t.decline}
          </button>
          <button onClick={onAccept} className="flex-1 px-4 py-3 text-white rounded-lg transition-colors font-medium" style={{
          backgroundColor: '#172637'
        }} onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#2d4a63';
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#172637';
        }} data-id="element-285">
            {t.accept}
          </button>
        </div>
      </div>
    </div>;
}